export default "__VITE_ASSET__DzJDW6rx__"